"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeSlot = exports.SubLocation = exports.appointmentTypeLabels = exports.appointmentTypes = void 0;
var appointmentTypes;
(function (appointmentTypes) {
    appointmentTypes[appointmentTypes["breastScreening"] = 99] = "breastScreening";
    appointmentTypes[appointmentTypes["healthCheck"] = 100] = "healthCheck";
    appointmentTypes[appointmentTypes["stepIntoAction"] = 106] = "stepIntoAction";
    appointmentTypes[appointmentTypes["virtualAssessment"] = 108] = "virtualAssessment";
    appointmentTypes[appointmentTypes["clinicalAssessment"] = 109] = "clinicalAssessment";
})(appointmentTypes = exports.appointmentTypes || (exports.appointmentTypes = {}));
exports.appointmentTypeLabels = {
    99: "Breast Screening",
    100: "Health Check",
    106: "Step Into Action",
    108: "Skin Cancer Early Detection (VR)",
    109: "Skin Cancer Early Detection (F2F)",
};
var SubLocation = /** @class */ (function () {
    function SubLocation() {
    }
    return SubLocation;
}());
exports.SubLocation = SubLocation;
var TimeSlot = /** @class */ (function () {
    function TimeSlot() {
    }
    return TimeSlot;
}());
exports.TimeSlot = TimeSlot;
//# sourceMappingURL=TimeSlot.js.map